import { Hero } from "../Hero";
import { Features } from "../Features";
import { Programs } from "../Programs";
import { Gallery } from "../Gallery";
import { Testimonials } from "../Testimonials";
import { CTA } from "../CTA";

export function Home() {
  return (
    <>
      <Hero />
      <Features />
      <Programs />
      <Gallery />
      <Testimonials />
      <CTA />
    </>
  );
}